<template>
  <div class="attitude_box">
    <div class="information_box" style="overflow: auto">
      <el-card
        v-for="(item, index) in note_l"
        :key="index"
        :style="{
          background:
            $filters.isTokenFn() &&
            $filters.isTokenFn().user_id === item.user_id
              ? '#fdf6ec'
              : ''
        }"
      >
        <span class="icon_mm">
          <svg class="icon" aria-hidden="true">
            <use
              xlink:href="#icon-weikaishi2
"
            ></use>
          </svg>
        </span>
        <h6>
          <span
            >[{{ item.sclass_name }}] {{ item.home_team_name }}
            <b>{{
              item.match_state === -1
                ? item.home_score + '-' + item.guest_score
                : $filters.match_state(item.match_state)
            }}</b>
            {{ item.guest_team_name }}</span
          >
        </h6>
        <div class="img_tit">
          <div class="picture_Luck">
            <img
              :src="`http://oss.deyity.com/img/user_photo/${item.user_photo}`"
            />
            <el-link type="primary" :underline="false" class="uesr_name">
              {{ item.user_name }}</el-link
            >
          </div>
          <div
            class="tit cuP"
            @click="fnRead(item.price, item.note_id, item.is_pay, item.user_id)"
          >
            <el-rate
              v-if="item.count"
              v-model="item.rate_value"
              disabled
              text-color="#ff9900"
            >
            </el-rate>
            <b
              class="activeR"
              v-if="item.first_choice >= 0 && 'first_choice' in item"
              >{{
                item.two_choice == null
                  ? item.note_type == 1
                    ? `单选:${choice_type[item.first_choice]}`
                    : item.note_type == 2
                    ? `单选:(${item.goal > 0 ? `+${item.goal}` : item.goal})主${
                        choice_type[item.first_choice]
                      }`
                    : item.note_type == 3
                    ? `单选:(${item.goal})${
                        item.first_choice == 3 ? '大球' : '小球'
                      }`
                    : ''
                  : `首选:${choice_type[item.first_choice]}&nbsp;&nbsp;&nbsp;`
              }}{{
                item.two_choice != null
                  ? `次选:${choice_type[item.two_choice]}`
                  : ''
              }}</b
            >
            <div class="content">
              {{ item.content }}
            </div>
            <p class="pp">
              <span>{{ item.public_time }}</span>
              <span v-if="item.price && !item.is_pay" class="activeR cuP"
                >付费阅读(￥{{ item.price }})</span
              >
              <span v-else-if="item.is_pay" class="activeR cuP"
                >已支付(￥{{ item.price }})</span
              >
              <span v-else class="pp_span">
                <span><i class="el-icon-s-promotion"></i>转发</span>
                <span><i class="el-icon-chat-dot-square"></i>评论</span>
                <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    <i class="el-icon-more"></i>
                  </span>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item>投诉</el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </span>
            </p>
          </div>
        </div>
      </el-card>
      <p v-if="loading" class="loading">加载中...</p>
      <p v-if="noMore" class="loading">没有更多了</p>
    </div>
  </div>
  <el-dialog
    v-model="dialogVisible"
    width="200px"
    center
    :destroy-on-close="true"
    @close="close_dialog"
  >
    <div class="tit">
      <el-radio-group v-model="pay_type" @change="payWayFn">
        <el-radio :label="1">微信</el-radio>
        <el-radio :label="2">支付宝</el-radio>
      </el-radio-group>
      <!-- <b class="activeR">请用微信支付</b>` -->
    </div>
    <div id="qrcode" ref="qrcode"></div>
  </el-dialog>
</template>
<script>
import {
  getCurrentInstance,
  ref,
  reactive,
  nextTick,
  onUnmounted,
  inject
} from 'vue'
import QRCode from 'qrcodejs2'
import { useRouter } from 'vue-router'
import '../../../assets/font/iconfont'
export default {
  setup(props) {
    console.log(props.match_obj)
    let router = useRouter()
    // 刷新
    const refresh = inject('reload')
    let { proxy: _this } = getCurrentInstance()
    let qs = require('qs')
    // 是否写笔记
    let loading = ref(true)
    let noMore = ref(false)
    // 笔记列表
    let pages = ref(1)
    let note_l = ref([])
    let note_list = async () => {
      let formData = reactive({
        page: pages.value
      })
      let { data: res } = await _this.$http.get(`/soccer/notes_list`, {
        params: formData
      })
      res.data.forEach((item) => {
        if (item.count) {
          item.rate_value =
            ((item.first_win_num + item.two_win_num) / item.count) *
            (5).toFixed(2)
        }
      })
      if (res.data.length === 0) {
        loading.value = false
        noMore.value = true
        _this.$notify({
          title: '提示',
          message: '已加载全部内容',
          type: 'error'
        })
      }
      note_l.value = note_l.value.concat(JSON.parse(JSON.stringify(res.data)))
      console.log(res)
    }
    // 无限滚动
    const load = () => {
      note_list()
      pages.value++
    }
    let onscrolla = () => {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      //滚动条到底部的条件
      if (scrollTop + windowHeight >= scrollHeight) {
        //到了这个就可以进行业务逻辑加载后台数据了
        load()
      }
    }
    window.addEventListener('scroll', onscrolla)
    load()
    // 支付方式
    let pay_type = ref(1)
    let payWayFn = (v) => {
      if (v === 2) {
        document.getElementById('qrcode').innerHTML = ''
        return _this.$notify({
          title: '提示',
          message: '暂不支持支付宝支付',
          type: 'error'
        })
      }
      pay_type.value = v
      clearInterval(timer.value)
      document.getElementById('qrcode').innerHTML = ''
      pay_bi()
    }

    let dialogVisible = ref(false)
    let note_id = ref(0)
    // 阅读
    let fnRead = async (v = 0, note_ids, is_pay, user_id) => {
      console.log(note_ids)
      note_id.value = note_ids
      if (!_this.$filters.isTokenFn())
        return _this.$notify({
          title: '提示',
          message: '请先登录账户',
          type: 'error'
        })
      // 需要付费
      if (v > 0 && !is_pay && _this.$filters.isTokenFn().user_id !== user_id) {
        dialogVisible.value = true
        pay_bi()
      } else {
        // 直接阅读
        let routeUrl = router.resolve({
          path: `/note_details/${note_ids}`
        })
        window.open(routeUrl.href, '_blank')
      }
    }
    // 支付订单生成
    let pay_bi = async () => {
      let { data: res } = await _this.$http.post(
        `/auth/user/pay_notes`,
        qs.stringify({ pay_type: pay_type.value, note_id: note_id.value })
      )
      nextTick(() => {
        new QRCode('qrcode', {
          width: 150,
          height: 150, // 高度
          text: res.data.code_url
        })
      })
      if (res.data.out_trade_no) {
        console.log(res.data.out_trade_no)
        we_chat_pay(res.data.out_trade_no)
      }
    }
    // 微信订单状态
    let timer = ref(0)
    let we_chat_pay = (out_trade_no) => {
      timer.value = setInterval(async () => {
        let { data: res } = await _this.$http.post(
          `/auth/user/we_chat_pay`,
          qs.stringify({ out_trade_no: out_trade_no })
        )
        if (res.code === 200) {
          console.log(res)
          if (res.data.pay_status > 0) {
            clearInterval(timer.value)
            _this.$notify({
              title: '提示',
              message: res.message,
              type: 'warning'
            })
            let routeUrl = router.resolve({
              path: `/note_details/${note_id.value}`
            })
            window.open(routeUrl.href, '_blank')
            refresh()
          }
        }
      }, 1000)
    }
    // 关闭定时器
    onUnmounted(() => {
      clearInterval(timer.value)
      window.removeEventListener('scroll', onscrolla)
    })
    let close_dialog = () => {
      clearInterval(timer.value)
    }
    return {
      note_l,
      choice_type: {
        3: '胜',
        1: '平',
        0: '负'
      },
      fnRead,
      close_dialog,
      dialogVisible,
      pay_type,
      payWayFn,
      load,
      loading,
      noMore
    }
  }
}
</script>
<style scoped lang="less">
.attitude_box {
  display: flex;
  justify-content: space-between;
  .el-card {
    position: relative;
    margin-bottom: 10px;
    .icon_mm {
      position: absolute;
      right: 10px;
      top: -30px;
      .icon {
        width: 80px;
      }
    }
    h6 {
      font-weight: 600;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 0 10px 0;
      .xz {
        font-size: 14px;
        padding: 2px 6px;
        background: red;
        border-radius: 4px;
        color: #fff;
      }
      .activeH5 {
        background: #606266;
      }
    }
    .img_tit {
      display: flex;
      justify-content: space-between;
    }

    .picture_Luck {
      width: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 40px;
        border-radius: 50%;
      }
      .uesr_name {
        text-align: center;
        // width: 80px;
        display: -webkit-box; /*将对象转为弹性盒模型展示*/
        -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
        -webkit-line-clamp: 1; /*限制文本行数*/
        overflow: hidden;
      }
      .Luck_box {
        .Luck_t {
          // width: 100%;
          // height: 20px;
          padding: 2px 10px;
          font-size: 12px;
          border-radius: 10px;
          background-color: #f56c6c;
          color: #eee;
        }
      }
    }
    .tit {
      width: 90%;
      &:hover .content {
        color: #409eff;
      }
      h6 {
        font-weight: 600;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0 10px 0;
        .xz {
          font-size: 14px;
          padding: 2px 6px;
          background: #409eff;
          border-radius: 4px;
          color: #fff;
        }
      }
      .activeH {
        // margin: 10px;
      }
      .content {
        background: #eee;
        padding: 10px;
        font-size: 14px;
        border-radius: 10px;
        margin: 10px 0;
      }
      .pp {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #8c8c8c;
        font-weight: 600;
        .pp_span {
          span {
            margin: 0 10px;
          }
        }
      }
    }
  }
}
.n_text_s {
  line-height: 60px;
  width: 100%;
  color: #909399;
  font-size: 12px;
  text-align: center;
}
.information_box::-webkit-scrollbar {
  width: 4px;
  /*height: 4px;*/
}
.information_box::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.information_box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
// .information_box {
//   height: 600px;
// }
.loading {
  color: #8c8c8c;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
</style>
